if (!customElements.get('totomo-slider')) {
  customElements.define('totomo-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.totomo-slides');
      this.slides = [...this.querySelectorAll('.totomo-slide')];
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches || this.dataset.autoplay !== 'true';
      this.pauseButton = this.querySelector('[data-pause]');
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), options);
      this.pauseButton.addEventListener('click', () => {this.paused = !this.paused; this.pauseButton.setAttribute('aria-pressed', String(this.paused));}, options);
      this.timer = setInterval(() => {if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.move(1);}, Number(this.dataset.interval) || 5000);
      document.addEventListener('shopify:block:select', e => {
        const slide = e.target.closest('.totomo-slide');
        if (slide && this.contains(slide)) { this.paused = true; this.track.scrollTo({left: slide.offsetLeft - this.slides[0].offsetLeft}); }
      }, options);
    }
    move(direction) {
      const width = this.track.clientWidth;
      const index = Math.round(this.track.scrollLeft / width);
      const next = (index + direction + this.slides.length) % this.slides.length;
      this.track.scrollTo({left: next * width, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {clearInterval(this.timer);this.abort.abort();}
  });
}
const setTotomoSidebar = () => {
  const desktop = matchMedia('(min-width: 990px)').matches;
  document.querySelectorAll('.totomo-mobile-categories').forEach(el => {el.open = desktop;});
};
setTotomoSidebar();
matchMedia('(min-width: 990px)').addEventListener('change', setTotomoSidebar);
document.addEventListener('shopify:section:load', setTotomoSidebar);

const totomoSetView = mode => {
 const main = document.querySelector('#MainContent');
 if (!main) return;
 main.classList.toggle('totomo-list-view', mode === 'list');
 main.querySelectorAll('[data-totomo-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.totomoView === mode)));
};
if (document.querySelector('#MainContent')?.dataset.template === 'collection.list') totomoSetView('list');
document.addEventListener('click', event => {
 const button = event.target.closest('[data-totomo-view]');
 if (button) totomoSetView(button.dataset.totomoView);
});
